<template lang="pug">
#view-render
  template(v-if="loadComplete")
    v-form-render(
      v-bind="$attrs",
      v-on="$listeners",
      :form-json="formJson",
      :form-data="formData",
      :option-data="optionData",
      :disabledMode="isDisabled",
      :primaryKeyValue="primaryKeyValue",
      :hiddenToken="hiddenToken",
      :globalDsv="globalDsv",
      :preview-state="previewState",
      :prjId="globalPrjId",
      :formId="formId",
      :prjField="prjField",
      :isInit="isInit",
      :flowLayoutType="flowLayoutType",
      ref="vFormRef",
      @updateFlowList="updateFlowList"
    )
      template(v-for="slot in Object.keys($scopedSlots)", v-slot:[slot]="scope")
        slot(:name="slot", v-bind="scope")
    //- .footer(v-if="hasSubmit")
      el-button(size="small", @click="handleCancel") 取 消
      el-button(type="primary", size="small", @click="submitForm") 确 定
  template(v-else)
    .empty 正在初始化表单
</template>

<script>
import metadataService from "@/CommonDP/service/metadata-service.js";
import { mapState } from "vuex";
import { getToken } from "@/CommonDP/utils";
import { V_FORM_ENUM } from "@/CommonDP/VForm/utils/enum";
import request from "@/CommonDP/utils/request";
import { cloneDeep, defaults } from "lodash-es";
export default {
  props: {
    // 表单id
    formId: {
      type: String,
      default: ""
    },
    editData: {
      type: Object,
      default() {
        return null;
      }
    },
    prjId: {
      type: String,
      default: ""
    },
    // 表单数据回显
    primaryKeyValue: {
      type: String,
      default: ""
    },
    // 表单禁止编辑模式
    isDisabled: {
      type: Boolean,
      default: false
    },
    formCode: {
      type: String,
      default: ""
    },
    // 表单显示提交按钮
    hasSubmit: {
      type: Boolean,
      default: false
    },
    // 自定义提交方法处理
    isCustomFun: {
      type: Boolean,
      default: false
    },
    state: {
      default: V_FORM_ENUM.create,
      type: Number
    },
    // 流程是发起(initiate)还是审批(approve)
    flowModeStatus: {
      type: String,
      default: "initiate"
    },
    transform: {
      type: Function,
      default: (data) => data
    },
    // 流程信息
    flowMessage: {
      type: Object,
      default: () => ({})
    },
    flowLayoutType: {
      type: String,
      default: "PC"
    },
    onSubmit: { type: [Function, undefined], default: undefined },
    onCancel: { type: [Function, undefined], default: undefined }
  },
  provide() {
    return {
      extraData: this.extraData,
      getSlaveTableList: () => this.formInfo.slaveTableList,
      getRawFormData: () => this.formData
    };
  },
  data() {
    return {
      formInfo: {
        slaveTableList: []
      },
      formJson: {},
      formData: {},
      endBackData: void 0, // 后端返回的数据
      isInit: false,
      optionData: {},
      previewState: false,
      loadComplete: false, // 表单加载完毕
      isNull: true, // true:新增；false：编辑,
      prjField: "", // 判断当前表单下prjId的字段,用于实时更新项目数据
      nextReadMode: false,
      throttleSubmitFlag: false,
      extraData: {} // 用于补充提交的数据
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    isRunTime() {
      return !this.previewState;
    },
    globalDsv() {
      return {
        appApi: process.env.VUE_APP_API,
        enterpriseId: this.enterpriseId,
        formId: this.formId,
        token: this.hiddenToken,
        flowModeStatus: this.flowModeStatus,
        flowInstanceId: this.flowInstanceId
      };
    },
    globalPrjId() {
      return this.prjId || this.$route.query.prjId || this.$store.state.projectMg.prjId;
    },
    $vformRef() {
      return this.$refs.vFormRef;
    },
    hiddenToken() {
      return "Bearer " + getToken();
    },
    flowInstanceId() {
      return this.flowMessage?.detail?.flowInstanceId;
    },
    formLayoutKey() {
      const { formId, formCode } = this;
      return formId || formCode;
    }
  },
  watch: {
    formLayoutKey: {
      handler() {
        this.queryDynFormJson();
      },
      immediate: true
    }
  },
  methods: {
    // 获取表单并展示
    async queryDynFormJson() {
      this.loading = true;
      this.loadText = "表单读取中...";
      try {
        const formJson = await this.getFormLayout();
        if (!formJson.formConfig || !formJson.widgetList) {
          console.warn("当前获取的json非缺少formConfig或者widgetList字段！");
          return;
        }
        if (this.primaryKeyValue) this.isNull = false;
        const [formData] = await Promise.all([this.showData(), this.getPrjIdKey()]);
        this.loading = false;
        this.loadComplete = true;
        await this.$nextTick();
        this.$vformRef.setFormJson(formJson);
        if (this.nextReadMode) {
          this.disableForm();
        }
        this.$emit("setFormData", formData);
        this.$emit("loadComplete");
      } catch (error) {
        this.loading = false;
        this.loadComplete = true;
      }
    },
    // 获取表单布局json数据
    async getFormLayout() {
      const { formId, formCode } = this;
      const hasForm = formId || formCode;
      if (!hasForm) throw new Error("未获取到formId或formCode");
      const server = formId ? metadataService.queryDynFormAllInfo(formId) : metadataService.queryDynFormAllInfoByFormCode(formCode);
      const {
        data: { json, slaveTableList }
      } = await server;
      this.formInfo.slaveTableList = slaveTableList;
      return JSON.parse(json);
    },
    // 获取本表单代表项目id的字段名
    async getPrjIdKey() {
      if (this.formId) {
        const { data } = await metadataService.getPrjIdField(this.formId);
        this.prjField = data;
      }
    },
    reset() {
      return this.$vformRef.resetForm();
    },
    async getFormData(needValidation = true) {
      if (needValidation) {
        await this.startValidate();
      }
      const formData = await this.$vformRef.getFormData(false);
      this.formatSubmitData(formData);
      return Object.assign({}, this.extraData, formData);
    },
    // 查询表单数据
    async showData() {
      if (this.editData) return this.editData;
      const { primaryKeyValue } = this;
      if (!primaryKeyValue) return {};
      const { data } = await metadataService.dynamicDetail({
        formId: this.formId,
        primaryKeyValue
      });
      this.endBackData = cloneDeep(data);
      return data || {};
    },
    // 表单校验
    startValidate() {
      const b = this.$vformRef.$refs.renderForm.validate();
      b.catch(() =>
        this.$nextTick().then(() => {
          const form = this.$el;
          const formItem = form.querySelector(".el-form-item.is-error");
          formItem.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "center"
          });
          // scrollToView({ el: formItem });
        })
      );
      return b.catch((error) => {
        for (const keyItem of Object.values(error)) {
          for (const item of keyItem) {
            const msg = item.message || "";
            throw msg.trim();
          }
        }
      });
    },
    // 设置表单数据
    async setFormData(formData) {
      this.isInit = true;
      const { isRunTime, isNull, prjField, globalPrjId } = this;
      if (isRunTime && isNull && prjField && globalPrjId && !formData[prjField]) this.$set(formData, prjField, globalPrjId);
      this.disposalSubformPrefix(formData, true);
      const data = this.transform(formData);
      this.formData = data;
      this.$vformRef.setFormData(data);
      await this.$nextTick();
      this.isInit = false;
    },
    // 设置表单权限
    async setFormPremission(list) {
      const formFieldList = cloneDeep(list);
      // 没有流程权限设置的字段
      const obj = await this.$vformRef.getFormData(false);
      // console.log("所有表单数据obj", obj);
      const array = Object.keys(obj);
      const ids = formFieldList.map((item) => item.formField);
      const nopremission = array.filter((item) => ids.indexOf(item) === -1);
      nopremission.forEach((item) => {
        this.$vformRef.disableWidgets(item);
      });
      // 处理子表权限getBasicData
      const subFormMap = {};
      const subTableList = this.formInfo.slaveTableList || [];
      for (const fieldItem of subTableList) {
        const form_name = fieldItem.slaveTableField;
        const subFormRef = this.$vformRef?.getWidgetRef(form_name);
        const {
          rowIdData = [],
          widget: { widgetList = [] }
        } = subFormRef;
        for (const {
          options,
          options: { name }
        } of widgetList) {
          // 临时存储子表下的配置数据,供后续更新
          subFormMap[name] = {
            // 当前字段的配置母板(新増行时,基于此配置更新)
            options,
            // 当前字段在父表的产生的实例
            refs: rowIdData.map((rowId) => this.$vformRef.getWidgetRef(`${name}@row${rowId}`))
          };
        }
      }
      for (const iterator of formFieldList) {
        if (iterator.children?.length > 0) {
          formFieldList.push(...iterator.children);
        }
      }
      for (const element of formFieldList) {
        const formField = element.formField;
        const ref = this.$vformRef.getWidgetRef(formField);
        const isSubForm = element.type === "custom-sub-form";
        // isCanView 是否可见 0：否；1：是
        // isCanUpdate 是否可修改 0：否；1：是
        // isRequired 是否必填 0：否；1：是"
        if (!element.isEnabled) {
          this.$vformRef.disableWidgets(formField);
          continue;
        }
        if (element.isCanView === 1) {
          this.$vformRef.showWidgets(formField);
        } else if (element.isCanView === 0) {
          this.$vformRef.hideWidgets(formField);
          continue;
        }
        if (element.isCanUpdate === 0) {
          if (isSubForm) {
            ref?.setInsertDisabled(true);
            ref?.setDeleteDisabled(true);
          } else {
            this.$vformRef.disableWidgets(formField);
          }
        } else {
          if (!isSubForm) {
            this.$vformRef.enableWidgets(formField);
          }
        }
        // 处理必填
        if (element.parentContainer) {
          // 子表下的字段
          const { options, refs } = subFormMap[formField] || {};
          const required = element.isRequired === 1;
          if (options) {
            // 对母板进行处理
            options.required = required;
            // 处理已实例化的组件
            for (const ref of refs) ref && ref.setRequired(required);
          } else {
            // 普通组件
            ref?.setRequired?.(element.isRequired === 1);
          }
        } else {
          ref?.setRequired?.(element.isRequired === 1);
        }
      }
    },
    // 禁止表单编辑
    disableForm() {
      this.nextReadMode = true;
      this.$refs?.vFormRef?.setReadMode?.(this.nextReadMode);
    },
    // 获取所有字段组件
    getFieldWidgets() {
      return this.$vformRef.getFieldWidgets();
    },
    translateKey(key) {
      const index = key.indexOf("-");
      return key.slice(index + 1);
    },
    // 将长key同步到短key中
    formatSubmitData(formData) {
      const subTableList = this.formInfo.slaveTableList || [];
      if (subTableList.length > 0) {
        for (const item of subTableList) {
          const fieldValue = formData?.[item.slaveTableField];
          const fullKey = `${item.slaveTableName}_${item.fieldNum}`;
          if (Array.isArray(fieldValue)) {
            for (const obj of fieldValue) {
              for (const key of Object.keys(obj)) {
                const firstIndex = key.indexOf(fullKey);
                const lastIndex = key.lastIndexOf(fullKey);
                if (firstIndex === lastIndex && firstIndex !== -1) {
                  const newField = this.translateKey(key);
                  this.$set(obj, newField, obj[key]);
                }
              }
            }
          }
        }
      }
    },
    // 子表深度赋值修改
    disposalSubformPrefix(formData, isAdd) {
      const subTableList = this.formInfo.slaveTableList || [];
      if (subTableList.length > 0) {
        for (const item of subTableList) {
          // 当前是动态表格，不需要对数据进行前缀处理
          if (item.widgetType === "jyht-table") break;
          const fieldValue = formData?.[item.slaveTableField];
          const fullKey = `${item.slaveTableName}_${item.fieldNum}`;
          if (Array.isArray(fieldValue)) {
            for (const obj of fieldValue) {
              for (const key of Object.keys(obj)) {
                const firstIndex = key.indexOf(fullKey);
                const lastIndex = key.lastIndexOf(fullKey);
                if (isAdd) {
                  const newField = firstIndex !== -1 ? key : `${fullKey}-${key}`;
                  this.$set(obj, newField, obj[key]);
                } else {
                  // 如果只有一个前缀则是标准key
                  if (firstIndex === lastIndex && firstIndex !== -1) {
                    const newField = this.translateKey(key);
                    this.$set(obj, newField, obj[key]);
                  }
                  // 直接删除所有带前缀得非标准key
                  if (firstIndex !== lastIndex && firstIndex !== -1) {
                    this.$delete(obj, key);
                  }
                }
              }
            }
          } else {
            console.warn("当前子表非数组！", formData, item.slaveTableField);
          }
        }
      }
    },
    async submitRequest(formData, requestUrl) {
      const {
        formId,
        isNull,
        primaryKeyValue,
        $attrs: { keyFieldName, paramsRule, selectList }
      } = this;
      if (this.throttleSubmitFlag) {
        throw new Error("throttle error");
      }
      this.throttleSubmitFlag = true;
      let url;
      const params = {};
      // 提交时，补充未初始化的数据
      const data = defaults({ ...formData }, this.endBackData);
      const paramName = paramsRule?.paramName;
      if (paramName && selectList?.length) {
        const paramType = paramsRule.paramType;
        const media = paramType === 0 ? data : params;
        media[paramName] = selectList.map((r) => r[keyFieldName]).join(",");
      }
      if (requestUrl) {
        url = requestUrl;
      } else if (isNull) {
        url = `/dyn-common/save/${formId}`;
      } else {
        url = `/dyn-common/update/${formId}`;
        params.id = primaryKeyValue;
      }
      try {
        this.loading = true;
        this.loadText = "表单数据保存中...";
        // 由于onSubmit是本地代码调用此组件传入的，因此比设计时写的处理脚本优先级更高
        const onFormSubmit = this.formJson.formConfig.onFormSubmit ? new Function('params', 'data', this.formJson.formConfig.onFormSubmit) : null;
        const disposalSubmitEvt = this.onSubmit || onFormSubmit;
        const afterFn = await disposalSubmitEvt?.(params, data);
        const { data: resData } = await request({ method: "post", url, params, data });
        this.$success("保存成功");
        this.$emit("submit", resData);
        await afterFn?.(resData);
        return resData;
      } finally {
        this.loading = false;
        this.throttleSubmitFlag = false;
      }
    },
    async submitForm(formData, url) {
      if (this.isCustomFun) {
        const afterFn = await this.onSubmit?.(formData);
        this.$emit("customFun", formData);
        return afterFn?.();
      } else {
        return this.submitRequest(formData, url);
      }
    },
    // 更新流程节点处理人
    updateFlowList(val) {
      this.$emit("change_showStartButtons", val);
    },
    async handleCancel() {
      await this.onCancel?.();
      this.$emit("cancel");
    }
  }
};
</script>

<style lang="scss" scoped src="./vFormRender.scss"></style>
<style scoped>
@import "~@/CommonDP/lib/vform/VFormDesigner.css";
</style>
<style lang="scss" scoped>
.main-header {
  display: none;
}

.left-aside-toggle-bar,
.right-aside-toggle-bar {
  height: 52px !important;
}
/deep/.el-input.is-disabled .el-input__inner,
/deep/.el-textarea.is-disabled .el-textarea__inner,
/deep/.el-range-editor.is-disabled input {
  background-color: #f4f7fc;
  border-color: #e4e7ed;
  color: #434c59;
}
/deep/.el-tag.el-tag--info {
  background-color: #f4f7fc;
  color: #434c59;
}
</style>
